import React, { useState } from 'react';
import { COLORS } from '../../utils/constants';

const PasswordInput = ({ 
  label, 
  placeholder, 
  value, 
  onChange,
  name,
  required = false,
  disabled = false,
  showForgot = false,
  onForgotClick
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div style={{ marginBottom: '20px', width: '100%' }}>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        marginBottom: '8px'
      }}>
        <label 
          htmlFor={name}
          style={{
            fontSize: '14px',
            fontWeight: '500',
            color: COLORS.black,
            opacity: disabled ? 0.6 : 1
          }}
        >
          {label}
        </label>
        {showForgot && (
          <button
            type="button"
            onClick={onForgotClick}
            disabled={disabled}
            style={{
              background: 'none',
              border: 'none',
              color: COLORS.blue,
              fontSize: '13px',
              fontWeight: '500',
              cursor: disabled ? 'not-allowed' : 'pointer',
              padding: '0',
              fontFamily: 'inherit',
              opacity: disabled ? 0.6 : 1
            }}
            onMouseEnter={(e) => {
              if (!disabled) {
                e.target.style.textDecoration = 'underline';
              }
            }}
            onMouseLeave={(e) => {
              e.target.style.textDecoration = 'none';
            }}
          >
            Forgot password?
          </button>
        )}
      </div>
      <div style={{ position: 'relative', width: '100%' }}>
        <input
          id={name}
          name={name}
          type={showPassword ? "text" : "password"}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          required={required}
          disabled={disabled}
          style={{
            width: '100%',
            padding: '14px 50px 14px 16px',
            fontSize: '15px',
            border: `2px solid ${COLORS.lightGray}`,
            borderRadius: '12px',
            outline: 'none',
            transition: 'all 0.3s ease',
            fontFamily: 'inherit',
            backgroundColor: disabled ? '#f5f5f5' : COLORS.white,
            boxSizing: 'border-box',
            cursor: disabled ? 'not-allowed' : 'text',
            opacity: disabled ? 0.6 : 1
          }}
          onFocus={(e) => {
            if (!disabled) {
              e.target.style.borderColor = COLORS.blue;
              e.target.style.boxShadow = `0 0 0 1px ${COLORS.blue}`;
            }
          }}
          onBlur={(e) => {
            if (!disabled) {
              e.target.style.borderColor = COLORS.lightGray;
              e.target.style.boxShadow = 'none';
            }
          }}
        />
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          disabled={disabled}
          style={{
            position: 'absolute',
            right: '16px',
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'none',
            border: 'none',
            cursor: disabled ? 'not-allowed' : 'pointer',
            padding: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: COLORS.gray,
            transition: 'color 0.2s ease',
            opacity: disabled ? 0.5 : 1
          }}
          aria-label={showPassword ? "Hide password" : "Show password"}
          onMouseEnter={(e) => {
            if (!disabled) {
              e.currentTarget.style.color = COLORS.black;
            }
          }}
          onMouseLeave={(e) => {
            if (!disabled) {
              e.currentTarget.style.color = COLORS.gray;
            }
          }}
        >
          {showPassword ? (
            // Eye with slash (hidden)
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
              <line x1="1" y1="1" x2="23" y2="23"/>
            </svg>
          ) : (
            // Eye (visible)
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
              <circle cx="12" cy="12" r="3"/>
            </svg>
          )}
        </button>
      </div>
    </div>
  );
};

export default PasswordInput;